import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routerHistory = createWebHashHistory();

// 路由配置
const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      requiresAuth: true, // 需要认证
      title: '屋内设备监控管理系统'
    },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/index.vue'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录 - 屋内设备监控管理系统',
      guestOnly: true // 仅游客可访问
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue'),
  },
  {
    path: '/hsScreen',
    name: 'hsScreen',
    meta: {
      requiresAuth: true,
      title: '大屏展示'
    },
    component: () => import(/* webpackChunkName: "hsscreen" */ '../views/hsScreen/indexView.vue'),
  },
  // 其他需要认证的页面...

  // 404页面 - 必须放在最后
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: {
      title: '页面不存在'
    },
    component: () => import(/* webpackChunkName: "notfound" */ '../views/error/404.vue')
  }
]

const router = createRouter({
  history: routerHistory,
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  }
})

// 路由守卫 - 认证检查
router.beforeEach((to, from, next) => {
  // 获取token
  const daToken = localStorage.getItem('daToken')

  // 设置页面标题
  document.title = to.meta.title || '设备管理平台'

  // 检查路由是否需要认证
  next()
  // if (to.meta.requiresAuth && !daToken) {
  //   // 如果需要认证但没有token，重定向到登录页
  //   next({
  //     path: '/login',
  //     query: { redirect: to.fullPath } // 保存跳转前的路径，用于登录后跳转
  //   })
  // }
  // // 检查是否为仅游客可访问的页面（如登录页）
  // else if (to.meta.guestOnly && daToken) {
  //   // 如果已登录但尝试访问游客页面，重定向到首页
  //   next('/')
  // }
  // // 其他情况正常放行
  // else {
  //   next()
  // }
})

// 路由错误处理
router.onError((error) => {
  console.error('路由错误:', error)

  // 如果是动态导入组件失败（可能是组件文件不存在），跳转到404
  const pattern = /Loading chunk (\w)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)

  if (isChunkLoadFailed) {
    // 删除已缓存的模块
    const targetPath = router.currentRoute.value.fullPath
    router.replace({
      path: '/404',
      query: { from: targetPath }
    })
  }
})

export default router